<ng-container [formGroup]="uploadFileForm" autocomplete="off">
  <div class="row mx-1 margin-top-btm share-document-folder-input-placeholder"
    [ngClass]="!isUserSupplier ? 'd-block' : 'd-none'">
    <mat-select placeholder="Select Supplier" [class.mat-sup-error]="uploadFileForm.controls.supplier.invalid &&
    uploadFileForm.controls.supplier.touched " formControlName="supplier" name="item" class="sg-select-sup">
      <input matInput class="search-box" formControlName="searchBox"
        placeholder="Search by Supplier Name, Supplier Code">
      <mat-option *ngFor="let item of suppliers" [value]="item">
        {{item.supplierName}} <span class="sg-supplier-code">{{item.organizationCode}}</span>
      </mat-option>
    </mat-select>
    <div *ngIf="
      uploadFileForm.controls.supplier.invalid &&
      uploadFileForm.controls.supplier.touched">
      <small class="text-danger">Please Select supplier </small>
    </div>
  </div>

  <div class="row mx-1 margin-top-btm" *ngIf="uploadFileName">
    <div class="col-sm-12 title-upload no-margin p-0 sg-select-sup sg-form-field-label "
      style="font-style:  normal !important;">
      Uploaded File
    </div>
    <div class="col-sm-12 no-margin p-0 sg-select-sup">
      {{ uploadFileName }}
    </div>
  </div>

  <div class="row mx-1 my-3">
    <div class="container-drag-drop-file w-100 sg-validation" appDnd (fileDropped)="onFileDropped($event)"
      [class.border-color]="
        (uploadFileForm.controls.filesToUpload.invalid &&
          uploadFileForm.controls.filesToUpload.touched) && uploadFileForm.controls.filesToUpload.hasError('required')  ||
        this.fileSizeValid">
      <input type="file" class="browse_button" #fileDropRef id="fileDropRef" formControlName="filesToUpload"
        (change)="fileBrowseHandler($event.target.files)" />
      <div class="sg-form-field-label d-flex justify-content-center flex-column font-weight-normal">
        <p class="mb-1">Drag & Drop your document</p>
        <mat-error *ngIf="mutipleFilesNotAllowed">
          Mutiple Files are Not Allow
        </mat-error>
        <div *ngIf="
            (!uploadFileForm.controls.filesToUpload.valid &&
              uploadFileForm.controls.filesToUpload.dirty) || 
            this.fileSizeValid
          ">
          <mat-error *ngIf="this.fileSizeValid">
            Upload must be less than: {{ fileSize }}MB
          </mat-error>
          <mat-error *ngIf="uploadFileForm.controls.filesToUpload.errors?.inValidExt || isExtensionNotValid">
            Not Valid File extension
          </mat-error>
        </div>
      </div>
      <div class="row mx-0 d-flex justify-content-center">
        <label for="fileDropRef" class="sg-primary-stroked mat-primary mat-stroked-button">Browse</label>
      </div>
    </div>
  </div>

  <small class="text-danger" *ngIf="
      uploadFileForm.controls.filesToUpload.touched &&
      uploadFileForm.controls.filesToUpload.hasError('required')
    ">File is Required.
  </small>

  <div class="row mx-1 pt-3">
    <label class="sg-form-field-label d-block font-weight-normal w-100">Document Type
      <span class="sg-form-field-required-marker ml-1">*</span>
      <span class="sg-infoicon">
        <p class="material-icons-outlined" [tooltip]="template" contentType="template" [options]="tooltipOptions"
          tooltipClass="tooltip-feedback">help_outline</p>
        <ng-template #template class="w-100">
          <div class="row mx-0 w-100">
            <div class="col-12 w-100 px-0">
              <p>Search and select Document Type from the list</p>
            </div>
          </div>
        </ng-template>
      </span>
    </label>

    <mat-form-field appearance="outline" class="w-75 sg-validation"
      [class.mat-form-field-invalid]=" !hasPermissions && uploadFileForm.controls.documentType.touched || invalidDocType || uploadFileForm.controls.documentType.touched && uploadFileForm.controls.documentType.hasError('required')">
      <input matInput type="text" formControlName="documentType" [matAutocomplete]="auto" />
      <mat-autocomplete #auto="matAutocomplete" autoActiveFirstOption (optionSelected)="onDocTypeSelected($event)">
        <mat-option *ngFor="let documentType of docTypesByPath?.filterList; let i = index"
          [value]="documentType.displayValue">
          {{ documentType.displayValue }}
        </mat-option>

      </mat-autocomplete>
    </mat-form-field>

    <div class="col-12 fileUploadPath sg-form-field-label label-hint font-style-italic" *ngIf="filePathToUpload!==''">
      Path to upload: {{filePathToUpload}}
    </div>
    <div class="alert-warning showWarning   d-flex flex-row" *ngIf="editFileMode && doctTypeWarning">
      <div>
        <span class="material-icons-outlined"> warning </span>
      </div>
      <div>{{ doctTypeWarningMsg }}</div>
    </div>
    <div class="col-12 pl-0">
      <small class="text-danger" *ngIf="invalidDocType && !uploadFileForm.controls.documentType.hasError('required')">
        Invalid Selection.
      </small>
    </div>
    <div class="col-12 pl-0">
      <small class="text-danger"
        *ngIf="!hasPermissions && !uploadFileForm.controls.documentType.hasError('required')">You have insufficient
        permissions to Upload this Document Type.
      </small>
    </div>
    <div *ngIf="
       uploadFileForm.controls.documentType.touched &&
      uploadFileForm.controls.documentType.hasError('required')
      ">
      <small class="text-danger" *ngIf="uploadFileForm.controls.documentType.hasError('required') ">
        Document Type is Required.
      </small>
    </div>
  </div>
  <div class="row mx-1 pt-3">
    <label class="sg-form-field-label d-block font-weight-normal w-100">
      Document Name
    </label>
    <div style="margin-bottom: 20px;" class="sg-form-field-label font-style-italic">
      {{ generatedDocumentNameValue }}
    </div>
    <mat-form-field class="w-75 d-none" appearance="outline">
      <input matInput formControlName="documentName" />
    </mat-form-field>
  </div>

  <div *ngIf="
      uploadFileForm.controls.documentName.invalid &&
      uploadFileForm.controls.documentName.dirty
    ">
    <small class="text-danger">Document Name is Required.</small>
  </div>
  <div class="row mx-1">
    <label class="sg-form-field-label d-block font-weight-normal w-100">
      Document Name Suffix
      <span class="sg-infoicon">
        <p class="material-icons-outlined" [tooltip]="templates" contentType="template" [options]="tooltipOptions"
          tooltipClass="tooltip-feedback">
          help_outline
        </p>
        <ng-template #templates class="w-100">
          <div class="row mx-0 w-100">
            <div class="col-12 w-100 px-0">
              <p>This Suffix will be added at the end of the Document Name. You can use it to make the Document Name
                unique
              </p>
            </div>
          </div>
        </ng-template>
      </span> 
    </label>
    <br />
    <mat-form-field class="w-75 sg-validation" appearance="outline">
      <input matInput formControlName="documentNameSuffix" maxlength="10" />
    </mat-form-field>
    <span class="sg-form-field-label label-hint w-100"><i>10 characters allowed</i></span>
  </div>
  <div class="alert-warning showWarning d-flex flex-row" *ngIf="suffixWarning">
    <div>
      <span class="material-icons-outlined"> warning </span>
    </div>
    <div>{{ suffixWarningMsg }}</div>
  </div>
  <div *ngIf="
      uploadFileForm.controls.documentNameSuffix.invalid &&
      uploadFileForm.controls.documentNameSuffix.dirty
    ">
    <small class="text-danger" *ngIf="!uploadFileForm.controls.documentNameSuffix.hasError('maxLength')">{{
      specialCharMsg }}
    </small>
  </div>

  <div class="row mx-1 mr-4 pt-2">
    <label class="sg-form-field-label d-block font-weight-normal w-100">Comments</label>
    <mat-form-field class="w-100 sg-validation" appearance="outline">
      <textarea matInput rows="3" formControlName="comments" maxlength="500"></textarea>
    </mat-form-field>
    <div *ngIf="
      uploadFileForm.controls.comments.invalid &&
      uploadFileForm.controls.comments.dirty
    ">
      <small class="text-danger">{{ specialCharMsg }}</small>
    </div>
  </div>
  
  <div class="row mx-1 mr-4 pt-2">
    <label class="sg-form-field-label d-block font-weight-normal w-100">Tags
      <span class="sg-infoicon">
        <p class="material-icons-outlined" [tooltip]="templatesTag" contentType="template" [options]="tooltipOptions"
          tooltipClass="tooltip-feedback">
          help_outline
        </p>
        <ng-template #templatesTag class="w-100">
          <div class="row mx-0 w-100">
            <div class="col-12 w-100 px-0">
              <p>You can add more than one Tag, separated by commas, for future document searches
              </p>
            </div>
          </div>
        </ng-template>
      </span> 
    </label>
    <mat-form-field class="example-chip-list w-100" appearance="outline">
      <mat-chip-list #chipList>
        <mat-chip *ngFor="let documentTags of documentTag" [selectable]="selectable"
                 [removable]="removable" (removed)="remove(documentTags)">
          {{documentTags}} 
          <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip>
        <input placeholder=""
               type="text"
               formControlName="tags"
               [matChipInputFor]="chipList"
               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
               [matChipInputAddOnBlur]="addOnBlur"
               (matChipInputTokenEnd)="add($event)">
      </mat-chip-list>
      <small class="text-danger" *ngIf="tagValueSize">
        Enter value with a limit of 20 characters
      </small>
      <small class="text-danger" *ngIf="tagLengthSize">
        you can add only 7 tags per document
      </small>
    </mat-form-field>
  </div>

 <ng-container *ngIf="isCommonControlsAvailable">
  <ng-container *ngFor="let formItem of dynamicCommonFormFields">
  <div class="row mx-1 mr-4 pt-2">
    <ng-container [ngSwitch]="formItem.type">
    <label class="sg-form-field-label d-block font-weight-normal w-100" *ngIf="formItem.label !== 'IsIntegratedWithSSS'">{{formItem.label}}
    </label>
    <ng-container *ngSwitchCase="'date'">
      <mat-form-field class="w-100 sg-validation" appearance="outline">
        <input  matInput [matDatepicker]="picker" [formControlName]="formItem.id">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </ng-container>
    <ng-container *ngSwitchCase="'Checkbox'">
      <mat-checkbox [formControlName]="formItem.id" style="display: none !important;"></mat-checkbox>
    </ng-container>
    
  </ng-container>
  </div>
  </ng-container>
</ng-container>

  <div class="row mx-1 pt-2 cursor" [ngClass]="!isArrowUpOrDown ? 'mb-5': 'mb-1'" *ngIf="isAdditionalInformationBlock">
    <p class="sg-form-field-label d-flex align-items-center">
      <b>Additional Information </b> 
      <span (click)="isArrowUpOrDown = !isArrowUpOrDown">
        <mat-icon *ngIf="isArrowUpOrDown" class="additional-info-toggle-icon">expand_less</mat-icon>
        <mat-icon *ngIf="!isArrowUpOrDown" class="additional-info-toggle-icon">keyboard_arrow_down</mat-icon>
      </span>
    </p>
  </div>

  <section class="flexible-content" *ngIf="isArrowUpOrDown && hasPermissions">
    <ng-container *ngFor="let formItem of dynamicFormFields">
      <div class="row mx-1 mb-2" *ngIf="shouldDisplayAdditionalField(formItem.id)">
        <label [ngStyle]="{'text-transform':formItem.label != 'Solar Part Number' ? 'capitalize' : ''}"
          class="sg-form-field-label d-block font-weight-normal w-100">
          {{formItem.label === "Solar Part Number" ? "Solar Part Number(s)" : 
          formItem.label === "Manufacturer Name" ? "Manufacturer (Operator) Name" : formItem.label}}
          <span *ngIf="formItem.id === 'typeofCertification'" class="sg-form-field-required-marker ml-1">*</span>
        </label>
        <ng-container [ngSwitch]="formItem.type">
          <!-- Input text -->
          <ng-container *ngSwitchCase="'text'">
            <mat-form-field class="w-75 sg-validation" appearance="outline">
              <input matInput type="text" class="form-control"  maxlength="{{formItem.maxLength}}" [formControlName]="formItem.id">
            </mat-form-field>
          </ng-container>

          <!-- Input number -->
          <ng-container *ngSwitchCase="'number'">
            <mat-form-field class="w-75 sg-validation" appearance="outline">
              <input matInput type="number" class="form-control"  maxlength="{{formItem.maxLength}}" [formControlName]="formItem.id">
            </mat-form-field>
          </ng-container>

          <!-- autocomplete -->
          <ng-container *ngSwitchCase="'autocomplete'">
            <mat-form-field class="w-75 sg-validation" appearance="outline">
              <input matInput type="text" [matAutocomplete]="matAuto" [class.mat-form-field-invalid]="invalidMaterial"
                [formControlName]="formItem.id" />
              <mat-autocomplete #matAuto="matAutocomplete">
                <mat-option *ngFor="let item of materialList; let i = index" [value]="item">
                  {{ item }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <div class="col-12">
              <small class="text-danger" *ngIf="invalidMaterial">Invalid Selection.</small>
            </div>
          </ng-container>

          <!-- Select menu -->
          <ng-container *ngSwitchCase="'select'">
            <mat-form-field appearance="outline" class="w-75 sg-validation">
              <mat-select placeholder="Please select" [formControlName]="formItem.id">
                <mat-option *ngFor="let item of formItem.list" [value]="item">
                  {{item}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </ng-container>

          <!-- checkbox   -->
          <ng-container *ngSwitchCase="'checkbox'">
            <mat-checkbox name="yes" type="checkbox" [formControlName]="formItem.id" class="my-2 mb-2"></mat-checkbox>
          </ng-container>

          <!-- date Picker  -->
          <ng-container *ngSwitchCase="'date'">
            <mat-form-field class="w-75 sg-validation" appearance="outline">
              <input  matInput [matDatepicker]="picker" [formControlName]="formItem.id">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </ng-container>
        </ng-container>
        <i class="sg-form-field-label d-block font-weight-normal w-100 label-hint" *ngIf="formItem.hint">
          {{formItem.hint}}
        </i>
        <mat-error *ngIf="uploadFileForm.controls[formItem.id].invalid &&
              (uploadFileForm.controls[formItem.id].dirty || uploadFileForm.controls[formItem.id].touched)">
          <small class="text-danger" *ngIf="uploadFileForm.controls[formItem.id].hasError('required')">This field is required.</small>
          <small class="text-danger" *ngIf="!uploadFileForm.controls[formItem.id].hasError('required')">{{ specialCharMsgSnPo }}</small>
        </mat-error>
      </div>
    </ng-container>
  </section>
</ng-container>
